import { defineComponent, onMounted, nextTick, ref, reactive, computed, watch, TransitionGroup } from 'vue'
import { useRoute } from 'vue-router'
import Card from 'ant-design-vue/lib/card'
import Input from 'ant-design-vue/lib/input'
import Select from 'ant-design-vue/lib/select'
import Drawer from 'ant-design-vue/lib/drawer'
import Form from 'ant-design-vue/lib/form'
import Interceptor from '../components/Interceptor'
import Popconfirm from 'ant-design-vue/lib/popconfirm'
// import SelectOption from 'ant-design-vue/lib/select-option'
import SelectServer from '../components/SelectServer'
import Loading from '../ui/Loading'

declare const io: any;
export default defineComponent(() => {

    const route = useRoute();
    const ajaxList = ref<any>([]);
    const $ajaxList = ref<any>();
    const info = ref<any>();
    const data = reactive({
        uid: '',
        listtype: 'all',
        input: '',
        visible: false,
        interceptor: null,
        modalVisible: false,
        baseUrl: '',
        port: ''
    })
    const interceptorList = ref<any>([])
    const socket = ref<any>()
    const list = computed(() => {
        if (data.listtype == 'all') {
            return ajaxList.value.filter((v: any) => v.url.indexOf(data.input) >= 0)
        }
        return ajaxList.value.filter((v: any) => v.method == data.listtype && v.url.indexOf(data.input) >= 0);
    })
    watch(() => data.visible, () => {
        if (data.visible == false) {
            data.interceptor = null;
        }
    })
    const deleteInterceptor = (data: any, index: number) => {
        const formData = new FormData();
        formData.append('url', data.url)
        formData.append('method', data.method)
        fetch(`${process.env.VUE_APP_BASE_API}/${route.query.key}/interceptor`, {
            body: formData,
            method: 'delete'
        }).then(() => {
            interceptorList.value.splice(index, 1);
        })
    }
    
    onMounted(() => {
        if (!route.query.key) {
            data.modalVisible = true
        } else {
            registered(route.query.key as any)
        }
    })
    const registered = (key: string) => {
        fetch(process.env.VUE_APP_BASE_API+'/check/'+key).then(v => v.json()).then(v => {
            if (v.data == false) {
                alert('连接不存在')
                data.modalVisible = true
            } else {
                init(key);
            }
            info.value = null;
            data.baseUrl = v.baseUrl;
            data.port = v.port
            console.log(v)
        })
    }

    const init = (key?: string) => {
        key = key || (route.query.key as any);
        if (socket.value) {
            socket.value.close();
            ajaxList.value = [];
            interceptorList.value = [];
        }
        socket.value = io.connect(process.env.VUE_APP_BASE_API, {
            query: `key=${key}`
        });
        console.log('连接socket')
        localStorage.setItem('username', key as any)
        socket.value.on('message',function({data: _data, type}: any){
            if (type == 'http') {
                var index = ajaxList.value.findIndex((v: any) => v.uid == _data.uid);
                if (index >= 0) {
                    ajaxList.value[index] = _data;
                    if (data.uid == _data.uid) {
                        info.value = _data;
                    }
                } else {
                    ajaxList.value.push(_data)
                }
                

                nextTick(() => {
                    $ajaxList.value.scrollTop = $ajaxList.value.scrollHeight  
                })
                console.log(data)
            }
        })
        fetch(`${process.env.VUE_APP_BASE_API}/${key}/interceptor`).then(v => v.json()).then(v => {
            interceptorList.value = v.data;
        })
    }

    return () => <div class='body layout-center'>
        <div class='layout-column'>
            <header class='mdui-appbar'>
                <div class='mdui-toolbar  mdui-color-theme'>
                    <div style={{flex: 1}}>
                        <div style={{lineHeight: '20px'}}>当前访问地址:<strong>{data.baseUrl}</strong>,&nbsp;&nbsp;当前连接: <strong>{route.query.key}</strong></div>
                        <div style={{lineHeight: '20px'}}>当前服务地址:<strong>{data.port}</strong></div>
                    </div>
                    <div style={{cursor: 'pointer'}} onClick={() => {
                        data.modalVisible = true
                    }}>切换连接</div>
                    <div style={{cursor: 'pointer'}} onClick={() => {
                        SelectServer.create();
                    }}>创建新连接</div>
                </div>
            </header>
            <div class='layout-row' style={{flex: 1, height: '1px'}}>
                <div style={{width:'300px',padding:'10px',boxSizing:'border-box'}}>
                    <div id="ajax-list" class='container layout-column' style={{}}>
                        <div style={{display: 'flex'}}>
                            <Select value={data.listtype} onChange={val => {
                                data.listtype = val
                            }}>
                                <Select.Option key='all' value='all'>all</Select.Option>
                                <Select.Option key='get' value='get'>get</Select.Option>
                                <Select.Option key='post' value='post'>post</Select.Option>
                                <Select.Option key='delete' value='delete'>delete</Select.Option>
                                <Select.Option key='put' value='put'>put</Select.Option>
                                <Select.Option key='head' value='head'>head</Select.Option>
                            </Select>
                            <Input placeholder='搜索' allow-clear style={{
                                border: '1px solid #f5f5f5',
                                borderLeft: 'none',
                                boxShadow: 'none'
                            }} onChange={val => {
                                data.input = val.target.value;
                            }} suffix={<svg onClick={() => {
                                ajaxList.value = [];   
                                info.value = null;
                            }} style={{width: '14px', height: '14px', cursor: 'pointer'}} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="64" height="64"><path d="M875.287273 1024H148.712727A111.243636 111.243636 0 0 1 37.469091 912.756364V389.352727A111.476364 111.476364 0 0 1 148.712727 279.272727h219.694546V111.243636A111.243636 111.243636 0 0 1 479.650909 0h79.825455a111.243636 111.243636 0 0 1 111.010909 111.243636V279.272727H875.287273a111.476364 111.476364 0 0 1 111.243636 111.243637v522.24A111.243636 111.243636 0 0 1 875.287273 1024zM148.712727 325.818182A64.930909 64.930909 0 0 0 84.014545 389.352727v523.403637A64.930909 64.930909 0 0 0 148.712727 977.454545H875.287273a64.930909 64.930909 0 0 0 64.698182-64.698181V389.352727A64.930909 64.930909 0 0 0 875.287273 325.818182h-215.272728a35.84 35.84 0 0 1-36.072727-35.84V111.243636A64.698182 64.698182 0 0 0 559.243636 46.545455H479.650909a64.698182 64.698182 0 0 0-64.465454 64.698181v177.570909A36.072727 36.072727 0 0 1 378.88 325.818182z" fill="#bfbfbf" ></path><path d="M60.741818 488.727273h902.283637v46.545454H60.741818zM323.956364 994.443636a23.272727 23.272727 0 0 1-23.272728-23.272727V617.192727a23.272727 23.272727 0 0 1 46.545455 0v353.978182a23.272727 23.272727 0 0 1-23.272727 23.272727zM474.298182 994.443636a23.272727 23.272727 0 0 1-23.272727-23.272727V700.043636a23.272727 23.272727 0 0 1 46.545454 0v271.127273a23.272727 23.272727 0 0 1-23.272727 23.272727zM774.981818 994.443636a23.272727 23.272727 0 0 1-23.272727-23.272727V700.043636a23.272727 23.272727 0 1 1 46.545454 0v271.127273a23.272727 23.272727 0 0 1-23.272727 23.272727z" fill="#bfbfbf"></path></svg>}>
                            </Input>
                        </div>
                        <div ref={$ajaxList} style={{flex: 1, height: '1px', scrollBehavior: 'smooth', marginTop: '10px', border: '1px solid #f5f5f5', overflow: 'auto'}}>
                            {list.value.length == 0 && <div class='container layout-center' style={{color: '#ccc'}}>
                                暂无接口请求
                            </div>}
                            <ul style={{margin: '0px',padding:'0px'}}>
                                { list.value.map((v: any) => <li key={v.uid} onClick={() => {
                                    data.uid = v.uid;
                                    info.value = v;
                                }} class={['main-left-li', v.status != 200 ? 'error' : '', data.uid == v.uid ? 'active' : '']}>
                                    {/* <div style={{position: 'relative', display: 'inline-block'}}>
                                        <TransitionGroup name='fade'> */}
                                            { v.requestLoading == false ? <span key='span' class={v.method}>{v.method}</span> : <Loading key='loading' style={{width: '20px', height: '20px', marginRight: '10px', position: 'relative', left: '-8px', top: '-3px', transform: 'scale(0.4)'}} />}
                                        {/* </TransitionGroup>
                                    </div> */}
                                    {v.url}
                                </li>) }
                            </ul>
                        </div>
                        <div style={{height: '300px', marginTop: '10px', border: '1px solid #f5f5f5'}}>
                            <div style={{padding: '5px 10px', borderBottom: '1px solid #f5f5f5'}}>
                                拦截器
                                <span style={{float:'right', cursor: 'pointer'}} onClick={() => {
                                    data.visible = true
                                }}>添加</span>
                            </div>
                            <div style={{height: 'calc(100% - 33px)', overflow: 'auto'}}>
                                <ul style={{margin: '0px',padding:'0px'}}>
                                    { Object.keys(interceptorList.value).map((v: any, index: number) => <li onClick={() => {
                                        data.visible = true
                                        data.interceptor = interceptorList.value[v]
                                    }} class={['main-left-li']}>
                                        <div style={{display: 'inline-block'}} onClick={(e: any) => {
                                                e.stopPropagation();
                                            }}>
                                            <Popconfirm title='确定删除拦截器吗' okText='确定' cancelText='取消' onConfirm={(e) => {
                                                const data = interceptorList.value[v];
                                                deleteInterceptor(data, index);
                                            }}>
                                                <img class='delete-icon' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFAElEQVR4Xu1bTYgcRRT+qnrYXaNGkoCy2UtQEomiIJig6CHRYC4qKCoR8bAL06/moqLswUNwBfGgYmCzu93VOwbBBSWCinqQ1ZCgIkQxKsbgT8SAGg8iBHNxkekntZlddmaqZ7o6PcMM9oO5TL/fj6r3U10t0COam5vbUCqV7mDmBwBcD2AzgMsBnAXwB4B3ASwS0YkeubRsRnTbmNZ6NI5j8jyvzMwm6E60KIRY8H3/tU6MeTzvKgBBEOySUr4C4OoMzh4hoj0Z5JxEugZAFEU7mPlzJ29amc8T0fqL1NFWvCsAhGF4nRDiuzwcF0Ic831/dx66bDpyB2B2dvayUqn0MYCbcnQ6IiLKUd+qqtwBCMPweSHE00nOCiEm4zj+UAjx+9LS0vlSqTTmeZ5JjvsB3JUkJ6W8uVwuf5k3CLkCEEXRNmb+IcHJ40R0S7sAtNYPAjhs42Hmg0qpx/oaAK31UwBeSnByMxGZet+WtNbPAJiyMJ0moq2d5F2f570CjjLzrmYn4jh+tlKp2IJq8df0DQBOAthoCWYvES26BtmOP28ATjHz9maDQoiHfd9/I63jYRguCCEeseiZ9H0/aYWlVd/A1wCA1npdHMfXArgiizYp5VsANlhWgFMZ8zxvjJkXmvUw8+vMHLn6Njw8/PPExMSvNrlVAKIouo+ZXwRwjauBAeF/j4jubVlV5o8gCPZKKT8YkEAyu2nLRcsrQGs9CeCFzJoHRNDWVS4DEEXRPrO/BiSOzG4yc6iUqqxVsLIC1gH4NOf2NbOj3RKM43h3pVI51gJAfRssz+1CiB1SSgNIA9nqe7cc7YLe48w8oZQ6ZU2CnQzW5/qjlvKWusHpZMP1eRRFLU2XS8O1Yi9VI1QAcOFkp1gBxRZoQiDLnnPd60n8RQ4okmBRBQajDJopE4A55PjM9/2v2+UAR97+ByAIgikppTniMnROCPGo7/vv20DQWptZZF8a3vr80t8AJDRP1pk8YRy38q6A1/dVwAYAM/+tlGo5bbKN40m8Aw2AcZ6IWtrvpq2yukNsvAUAdQQGcgsUK6DYAkUOKJJgUQWKMlj0AUUj1DwMFZ1g49RYtMIrCBSzgKViFMNQMQxdQKCYBvv9WDzpfeL/vRX+kYjMJawGSrigYeUdmCQ4PT29fmRk5CwzX7om2jeJ6CFLI7TF87yTTbxt7wf3fQ4wQdZvjR8CsJWZDymlzF0kK9VXwROGN47jg50uVg4EAEnB5vF/TwHQWt8O4JNmx/vt7TAz71dKPecCcKobIvPz8zfGcfxNPwGgtT5tudT5OBFN5w5AEARbpJS/9BkA/wAYXutTHMfjlUrl1dwBqFarG2u12l8Wxe8QkXn52VOq3yg3n9s1kBDift/333ZxJtUWmJqaKo2Ojv5rUXyOmXcqpX5yMXqxvNVq9bZarWbuNTYQM+9RSh1x0Z8KAKNQa/0bgDGL8o8APElE37oYzsobhuGtUsp5ZjYfXzbTdiL63kW3CwCmCphqkERnhBBnXIy78jLzDQA2JckNDQ1dMj4+bnJDanIBwDQpB1Jr7jFj1s/rUgMQBMGVnud9lfLz1x6HD2TtSVIDYCKKokgxc9Dz6Dob/IKIdnZma+VwAsCIh2F4pxBiDsC2LAa7IHNASvlyuVw2SdqZnAEwFmZmZjZ5nnePlPJuM7wAuKr+c3bAUeAcgD/Nr/7x5WHbDXAXnf8BCqrOfRQs1jgAAAAASUVORK5CYII=" />
                                            </Popconfirm>
                                        </div>
                                        <span class={interceptorList.value[v].method}>{interceptorList.value[v].method}</span>{interceptorList.value[v].url}
                                    </li>)}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{flex: 1, padding:'10px',boxSizing:'border-box', width: '1px'}}>
                    {info.value && <div class='container' style={{border: '1px solid #f5f5f5', overflow: 'auto',padding: '10px'}}>
                        <div class='ajax-info'>
                            <span>请求方式: </span> 
                            <div>{info.value.method}</div>
                        </div>
                        <div class='ajax-info'>
                            <span>请求路径: </span> 
                            <div>{info.value.url}</div>
                        </div>
                        <div class='ajax-info'>
                            <span>mock: </span> 
                            <div>{info.value.mock == 'true' ? 'true' : 'false'}</div>
                        </div>
                        { info.value.requestLoading == false && <div class='ajax-info'>
                            <span>请求耗时: </span> 
                            <div>{info.value.time}ms</div>
                        </div> }
                        
                        <div class='ajax-info'>
                            <span>状态码: </span> 
                            <div>
                                { info.value.requestLoading == false ? info.value.status : '获取结果中' }
                            </div>
                        </div>
                        <div class='ajax-info'>
                            <span>请求头: </span> 
                            <div>
                                <pre>
                                    {JSON.stringify(info.value.headers, null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div class='ajax-info'>
                            <span>参数: </span> 
                            <div>
                                <pre>
                                    {JSON.stringify(info.value.query, null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div class='ajax-info'>
                            <span>body: </span> 
                            <div>
                                <pre>
                                    {JSON.stringify(info.value.body, null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div class='ajax-info'>
                            <span>返回体积: </span> 
                            <div>{info.value.size ? parseFloat(info.value.size/1000 as any).toFixed(2) : 0} kb</div>
                        </div>
                        <div class='ajax-info'>
                            <span>返回值: </span> 
                            <div>
                                { info.value.requestLoading == false ? <pre>
                                    {JSON.stringify(info.value.data, null, 2)}
                                </pre> : '获取结果中' }
                            </div>
                        </div>
                    </div>}
                    
                </div>
            </div>
        </div>
        <Interceptor visible={data.visible} content={data.interceptor} onClose={() => {
            data.visible = false;
        }} onSuccess={(val: any) => {
            const index = interceptorList.value.findIndex((v: any) => v.uid == val.uid) ;
            if (index == -1) {
                interceptorList.value.push(val);
            } else {
                interceptorList.value[index] = val;
                
            }
            data.visible = false;
        }} />
        <SelectServer visible={data.modalVisible} onClose={(result: any) => {
            data.modalVisible = false;
            if (result) {
                registered(result);
                // location.reload()
            }
        }} />
    </div>
})